// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2WjgR","title":"Info_title__1oG-x","selects":"Info_selects__2hrNU","requiredAsterisk":"Info_requiredAsterisk__11mHJ"};